function getActiveDimensions() {
  const params = new URLSearchParams(location.search);
  const values = params.getAll("filter.p.m.custom.dimensions");

  return values.length ? values : null;
}

function isVacuumACollection() {
  return (
    location.pathname.includes("/collections/tables") ||
    location.pathname.includes("/collections/complete-systems")
  );
}

async function renderGenericAccessories() {
  const target = document.querySelector("#accessory-upsell-target");
  if (!target) return hideUpsellSection();

  target.innerHTML = "";

  const accessories = [
    { label: "Fixture Plate", handle: window.accessoryProducts.fixture_plate },
    { label: "Spoilboard", handle: window.accessoryProducts.spoilboard }
  ];

  let count = 0;

  for (const acc of accessories) {
    const product = await fetchProduct(acc.handle);
    if (!product) continue;

    count++;

    target.appendChild(
      buildAccessoryCard({
        label: acc.label,
        handle: product.handle,
        image: product.featured_image,
        productTitle: product.title,
        price: product.price
      })
    );
  }

  if (count === 0) hideUpsellSection();
  else showUpsellSection();
}



function hideUpsellSection() {
  const block = document.querySelector(".accessory-upsell");
  if (block) block.style.display = "none";
}

function resolveAccessoryDimension(dim) {
  const value = dim.toLowerCase();

  if (value === "32x32") {
    return "16x16";
  }

  if (value.includes("48x48") && value.includes("4-zone")) {
    return "24x24";
  }

  if (value.includes("48x48") && value.includes("2-zone")) {
    return "24x48";
  }

  return dim;
}

async function initAccessoryUpsell() {
  const hasDimensionFilter = location.search.includes("filter.p.m.custom.dimensions=");

  if (!hasDimensionFilter) {
    if (isVacuumACollection()) {
      renderGenericAccessories();
      return;
    }

    hideUpsellSection();
    return;
  }

  const rawDimensions = getActiveDimensions();
  if (!rawDimensions) return hideUpsellSection();

  const dimensions = rawDimensions.map(resolveAccessoryDimension);

  const target = document.querySelector("#accessory-upsell-target");
  if (!target) {
    hideUpsellSection();
    return;
  }

  target.innerHTML = "";
  let matchCount = 0;

  const accessories = [
    { label: "Fixture Plate", handle: window.accessoryProducts.fixture_plate },
    { label: "Spoilboard", handle: window.accessoryProducts.spoilboard }
  ];

  for (const dim of dimensions) {
    for (const acc of accessories) {
      const product = await fetchProduct(acc.handle);
      if (!product) continue;

      const variant = product.variants.find(v =>
        v.title.toLowerCase().includes(dim.toLowerCase())
      );

      if (!variant) continue;

      matchCount++;

      const img = (variant.featured_image && variant.featured_image.src) || product.featured_image;

      target.appendChild(
        buildAccessoryCard({
          label: acc.label,
          handle: product.handle,
          variantId: variant.id,
          image: img,
          dimension: dim,
          productTitle: product.title,
          variantTitle: variant.title,
          price: variant.price
        })
      );
    }
  }

  if (matchCount === 0) hideUpsellSection();
  else showUpsellSection();
}

function showUpsellSection() {
  const block = document.querySelector(".accessory-upsell");
  if (block) block.style.display = "block";
}

async function fetchProduct(handle) {
  try {
    const res = await fetch(`/products/${handle}.js`);
    return await res.json();
  } catch (err) {
    return null;
  }
}

function formatMoney(cents) {
  return `$${(cents / 100).toFixed(2)}`;
}

function buildAccessoryCard(data) {
  const url = data.variantId
    ? `/products/${data.handle}?variant=${data.variantId}`
    : `/products/${data.handle}`;

  const card = document.createElement("a");
  card.className = "accessory-upsell__card";
  card.href = url;

  card.innerHTML = `
    <div class="accessory-upsell__imageWrap">
      <img src="${data.image}" alt="${data.label}" loading="lazy" class="accessory-upsell__image" />
    </div>
    <div class="accessory-upsell__content">
      <h3 class="accessory-upsell__product">${data.productTitle}</h3>
      ${data.variantTitle ? `<p class="accessory-upsell__variant">${data.variantTitle}</p>` : ""}
      <p class="accessory-upsell__price">${formatMoney(data.price)}</p>
    </div>
  `;

  requestAnimationFrame(() => {
    card.classList.add("is-visible");
  });

  return card;
}
{/* <h3 class="accessory-upsell__label">${data.label}</h3> */}

document.addEventListener("DOMContentLoaded", initAccessoryUpsell);
document.addEventListener("collection:updated", () => {
  setTimeout(initAccessoryUpsell, 50);
});